export default __webpack_public_path__ + "static/media/callRequestCenter.ce244fd9.gif";